import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Spinner
} from "reactstrap";
import Select from 'react-select'

// style
import "../../../assets/css/loading.css";

// helpers
import {InputCNPJ} from "../../../helpers/mask.js";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

export default function ConcessionariasForm({history, handleReturn, item}) {
    const session = getSessionCookie();
    
    const { register, handleSubmit, errors, setError, setValue, clearErrors } = useForm({ mode: "onBlur" });

    const [showLoading, setshowLoading] = React.useState(false);

    const options_status = [
        { value: 'Ativo', label: 'Ativo' },
        { value: 'Inativo', label: 'Inativo' }
    ];
    const [status, setStatus] = React.useState("");    
    const handleStatus = (value) => {
        setStatus(value);
        clearErrors("status");
    }

    const [cnpj, setCnpj] = React.useState("");
    const handleCNPJ = (event) => {
        setCnpj(event.target.value);
        clearErrors("cnpj");
    }

    const [optionsModalidadesColeta, setoptionsModalidadesColeta] = React.useState([]);
    const [modalidadesColeta, setModalidadesColeta] = React.useState([]);
    const loadOptionsModalidadesColeta = () => {        
        api_GET('modalidadecoleta').then(result => {                        
            if (result.status !== 200) {
              showMessage("Aviso", result.message, 'error', null);
            }
            else{
                setoptionsModalidadesColeta(result.data);
            }
          });
    }
    const handleModalidadesColeta = event => {
        let value = event;
        let lstSelect = [];
        value.map(item =>{
            lstSelect.push({
                concessionariaId: item == null ? 0 : item.concessionariaId,
                modalidadeColetaId: item.modalidadeColetaId
            });
        });
        setModalidadesColeta(lstSelect);
    }

    const onSubmit = (data) => {    
                
        if (status == "")
        {
            setError("status");
            return;
        }

        if (cnpj.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "").replaceAll("_", "").length != 14){
            setError("cnpj");
            return;
        }        

        let json_submit = {
            concessionariaId: item == null ? 0 : item.concessionariaId,
            identificacao: data.identificacao,
            cnpj: cnpj.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "").replaceAll("_", ""),
            fantasia: data.fantasia,
            razaoSocial: data.razaosocial,
            contato: data.contato,
            ativo: (status == "Ativo" ? true : false),
            usuarioCadastroId: session.usuarioId,
            usuarioAtualizacaoId: session.usuarioId,
            concessionariaModalidadeColeta: modalidadesColeta
        }

        setshowLoading(true);
        if(json_submit.concessionariaId == 0){
            api_POST('concessionaria',json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error' , null);
                }
                else{
                    showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                        handleReturn(result.data);
                    });
                }
            });
        }
        else{
            api_PUT('concessionaria',json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error' , null);
                }
                else{
                    showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                        handleReturn(result.data);
                    });
                }
            });
        }
    };

    useEffect(() => {    
        loadOptionsModalidadesColeta();    
        setValue("identificacao", item == null ? "" : item.identificacao);        
        setValue("fantasia", item == null ? "" : item.fantasia);
        setValue("razaosocial", item == null ? "" : item.razaoSocial);
        setValue("contato", item == null ? "" : item.contato);
        if (item != null){
            setStatus(item.ativo ? "Ativo" : "Inativo");
            setCnpj(item.cnpj);            
            setModalidadesColeta(item.concessionariaModalidadeColeta);
        }
    }, [item]);

    return (
    <>   
    <div>{showLoading && 
          <div className="carregandoCmp">
              <div className="box">
                <label style={{marginRight:"20px"}}>Carregando...</label>
                <Spinner size="sm" color="info" />
              </div>
          </div> 
        }
        <Row>
            <Container fluid>
                <Card className="shadow">

                    <CardHeader className="border-0">
                        <strong> Cadastro de Concessionária</strong>
                    </CardHeader>
                    <CardBody>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Identificação
                                        </label>
                                        <Input                                            
                                            name="identificacao"
                                            placeholder="Identificação"
                                            type="text"
                                            maxLength={200} 
                                            innerRef={register({ required: true})}                                        
                                        />
                                        {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * CNPJ
                                        </label>
                                        <InputCNPJ                                                
                                            name="cnpj"
                                            placeholder="CNPJ"
                                            value={cnpj}                                            
                                            onChange={handleCNPJ}  
                                            inputRef={register({ required: true})}                                        
                                        />
                                        {errors.cnpj && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>  
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Fantasia
                                        </label>
                                        <Input                                            
                                            name="fantasia"
                                            placeholder="Fantasia"
                                            type="text"
                                            maxLength={200} 
                                            innerRef={register({ required: true})}                                        
                                        />
                                        {errors.fantasia && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>   
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Razão Social
                                        </label>
                                        <Input                                            
                                            name="razaosocial"
                                            placeholder="Razão Social"
                                            type="text"
                                            maxLength={200} 
                                            innerRef={register({ required: true})}                                        
                                        />
                                        {errors.razaosocial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>   
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Contato
                                        </label>
                                        <Input                                            
                                            name="contato"
                                            placeholder="Contato"
                                            type="text"
                                            maxLength={200} 
                                            innerRef={register({ required: true})}
                                        />
                                        {errors.contato && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>                             
                                <Col md="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Status
                                        </label>
                                        <Select
                                            options={options_status}
                                            name="status"
                                            onChange={(e) => {handleStatus(e.value)}}
                                            value={options_status.find(obj => obj.value === status)}
                                            placeholder="Selecione"                                                                             
                                        />
                                        {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Modalidades de Serviço
                                        </label>
                                        <Select
                                            options={optionsModalidadesColeta}
                                            name="modalidadeColeta"
                                            getOptionLabel={({descricao}) => descricao}
                                            getOptionValue={({modalidadeColetaId}) => modalidadeColetaId} 
                                            onChange={(value) => {handleModalidadesColeta(value || [])}}
                                            value={optionsModalidadesColeta.filter(({modalidadeColetaId}) => modalidadesColeta.filter(f => f.modalidadeColetaId == modalidadeColetaId).length > 0)}
                                            placeholder="Selecione"
                                            isMulti="true"
                                        />
                                        {errors.modalidades_coleta && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12" className="text-center">                                
                                <FormGroup>
                                    <Button color="warning" type="button" onClick={() => {handleReturn()}}>Voltar</Button>
                                    <Button color="success">Salvar</Button>
                                </FormGroup>
                                </Col>
                            </Row>

                        </form>
                    </CardBody>
                </Card>
            </Container>
        </Row>        
        </div>             
    </>
    );
}
